<template>
  <div class="card-922">
    <div class="card " data-slot="default">
      <div class="card__bg"
           :style="`background-image: url(${image})`"></div>
      <div class="card__content">
        <slot name="p-1">
          <p class="text-white">Lorem ipslitia.</p>
        </slot>
      </div>
      <div class="card__badges">
        <slot name="p-2">
          <h3>alsdnlasnd</h3>
        </slot>
      </div>
    </div>
    <slot name="p-3"></slot>
  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card922",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },
}

</script>

<style scoped>
.card {
  width: 100%;
  height: 250px;
  border: none;
  position: relative;
  transition: all 0.5s ease-out;
  background: transparent;
}

.card__bg {
  position: relative;
  height: 100%;
  background-size: cover;
  background-position: center center;
  border-radius: 1rem;
  overflow: hidden;
  transform: scale(1);
  transition: all 0.5s ease-out;
}

.card__bg::after {
  content: "";
  background-image: linear-gradient(360deg, black, transparent);
  height: 150px;
  bottom: 0;
  width: 100%;
  position: absolute;
}

.card__content {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
}

.card__badges {
  position: absolute;
  top: 3%;
  right: 3%;
}

</style>